import { ESourceSystem } from '@if/core/types'
import { ControlledCheckbox, ControlledDateOnlyPicker, ControlledSinField, ControlledTextField } from '@if/mui'
import { Box, Button, Paper, Typography } from '@mui/material'
import { BanishmentFilter, BanishmentFilterForm } from '@src/data/types'

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export interface BanishmentSearchFiltersProps {
  onSubmit: (values: BanishmentFilter) => void
  onClear: () => void
  defaultValues?: BanishmentFilter
}

const emptyFilterValues: BanishmentFilterForm = {
  firstName: null,
  lastName: null,
  birthDate: null,
  sin: null,
  isMonolith: false,
}

const BanishmentSearchFilters: React.FC<BanishmentSearchFiltersProps> = ({
  onSubmit,
  onClear,
  defaultValues = emptyFilterValues,
}) => {
  const { t } = useTranslation()
  const {
    control,
    handleSubmit: formHandleSubmit,
    reset,
  } = useForm<BanishmentFilterForm>({
    defaultValues,
    mode: 'onSubmit',
  })

  const handleClear = () => {
    reset(emptyFilterValues)
    onClear()
  }

  const submitForm = (data: BanishmentFilterForm) => {
    onSubmit({
      ...data,
      sourceSystem: data.isMonolith ? ESourceSystem.Monolith : null,
    })
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" component="h2" gutterBottom>
        {t('banishments.filters.title')}
      </Typography>
      <form onSubmit={formHandleSubmit(submitForm)}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <ControlledTextField
            name="firstName"
            control={control}
            sx={{ width: { xs: '100%', sm: '48%', md: '30%', lg: '22%' } }}
            label={t('banishments.filters.firstName')}
            margin="normal"
            fullWidth={false}
          />

          <ControlledTextField
            name="lastName"
            control={control}
            sx={{ width: { xs: '100%', sm: '48%', md: '30%', lg: '22%' } }}
            label={t('banishments.filters.lastName')}
            margin="normal"
            fullWidth={false}
          />

          <ControlledDateOnlyPicker
            name="birthDate"
            control={control}
            sx={{ width: { xs: '100%', sm: '48%', md: '30%', lg: '22%' } }}
            label={t('banishments.filters.birthDate')}
            fullWidth={false}
            slotProps={{
              textField: {
                margin: 'normal',
              },
            }}
          />

          <ControlledSinField name='sin' control={control} label={t('banishments.filters.sin')} sx={{ width: { xs: '100%', sm: '48%', md: '30%', lg: '22%' } }}
            margin="normal" fullWidth={false} />



          <Box sx={{ width: { xs: '100%', sm: '48%', md: '30%', lg: '22%' }, display: 'flex', alignItems: 'center' }}>
            <ControlledCheckbox name='isMonolith' control={control} label={t('banishments.filters.monolithOnly')} />
          </Box>
          <Box sx={{ width: '100%', display: 'flex', gap: 2, mt: 2 }}>
            <Button type="submit" variant="contained" color="primary">
              {t('banishments.filters.search')}
            </Button>
            <Button type="button" variant="outlined" onClick={handleClear}>
              {t('banishments.filters.clear')}
            </Button>
          </Box>
        </Box>
      </form>
    </Paper>
  )
}

export default BanishmentSearchFilters
